import React, { useEffect, useRef } from 'react';

const VideoComponent = () => {
    const videoRef = useRef(null);
    const reelClickedRef = useRef(false);

    useEffect(() => {
        const videoElement = videoRef.current;
        if (!videoElement) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        videoElement.play();
                        document.body.classList.add('siteOnVideo');
                    } else {
                        videoElement.pause();
                        document.body.classList.remove('siteOnVideo');
                    }
                });
            },
            { threshold: 0.25 }
        );

        observer.observe(videoElement);

        return () => {
            observer.unobserve(videoElement);
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (reelClickedRef.current) {
                if (window.scrollY < 50) {
                    document.body.classList.add('bodyOnReel');
                } else {
                    document.body.classList.remove('bodyOnReel');
                    reelClickedRef.current = false;
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const base = `${process.env.PUBLIC_URL}/videos`;

    return (
        <section className='videoHome' name='home'>
            <div id="videoIndex" className="videoIndex">
                <video
                    ref={videoRef}
                    preload="metadata"
                    poster={`${base}/index-desktop.webp`} 
                    muted
                    loop
                    playsInline
                >
                    <source
                        src={`${base}/index-mobile.mp4`}
                        media="(max-width: 768px)"
                        type="video/mp4"
                    />

                    <source
                        src={`${base}/index-desktop.mp4`}
                        media="(min-width: 769px)"
                        type="video/mp4"
                    />
                </video>
            </div>
            <div className="homeText">
                <p className='videoBajada'>
                    <a href='/works' className='buttonIndex'>Works</a>
                    <a href='/contact' className='buttonIndex'>Contact</a>
                </p>
            </div>
            <div className='arrowDownIndex'>
                <svg class="scroll-indicator" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 215.9 460.4">
                <g class="mouse">
                    <path d="M108.5,7.2h0C52.8,7.2,7.3,52.7,7.3,108.3v119.9c0,55.6,45.5,101.2,101.2,101.2h0c55.6,0,101.2-45.5,101.2-101.2v-119.9c0-55.6-45.5-101.2-101.2-101.2ZM195.6,228.3c0,23.2-9.1,45-25.6,61.6-16.5,16.5-38.4,25.6-61.6,25.6s-45-9.1-61.6-25.6c-16.5-16.5-25.6-38.4-25.6-61.6v-119.9c0-23.2,9.1-45,25.6-61.6,16.5-16.5,38.4-25.6,61.6-25.6s45,9.1,61.6,25.6,25.6,38.4,25.6,61.6v119.9Z"/>
                    <rect class="wheel" x="94.4" y="68.1" width="28" height="60.5" rx="12" ry="12"/>
                </g>
                <path class="arrow" d="M181.1,386.9c-2.4-3-6.8-3.5-9.8-1.1l-62.8,49.7-62.8-49.7c-3-2.4-7.4-1.9-9.8,1.1-2.4,3-1.9,7.4,1.1,9.8l67.1,53.1c1.3,1,2.8,1.5,4.3,1.5s3.1-.5,4.3-1.5l67.1-53.1c3-2.4,3.5-6.8,1.1-9.8Z"/>
                </svg>
            </div>
        </section>
    );
};

export default VideoComponent;